import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import {QuestionBase} from "../../../../core/components/dynamic-form/models/question-base";

export class FascicoloPrevidenziale extends FascicoloFull {
  constructor() {
    super();
    this.dataInizioFascicolo = +new Date();
  }

  get form(): QuestionBase[] {
    return this.baseForm;
  }
}
